module.exports = "/_next/static/files/7e92e440360c26fcfbc419fed0ae038e.jpg";